module.exports = __webpack_public_path__ + "img/user-actif.039cc500.svg";